/**
 * 将对象序列化为 application/x-www-form-urlencoded 格式字符串。
 * 过滤掉 undefined 值，将其他值转为字符串。
 */
export function toFormBody(data: Record<string, any>): string {
  const params = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });
  return params.toString();
}
